import { CancelTokenSource } from "axios";
import {
  axiosSecuredInstance,
  cancelToken,
} from "configurations/axiosConfig";
import ProductOption from "entities/UIModel/company/ProductOption";
import { StateProductConfig } from "entities/UIModel/company/StateProductConfig";
import {
  StoreActionApi,
  createHook,
  createStore,
} from "react-sweet-state";
// import { ProductTabSortOrder, ProductType } from "utils/data/enum";
import { orderBy } from "lodash";
// import { ActionResult } from "entities/UIModel";
import { getProductTabSortOrder } from "pages/file/utils/productActionHelper";

type State = {
  isLoadingStateProductConfig: boolean;
  stateProductConfig: StateProductConfig;
  axiosCancelToken?: CancelTokenSource;
};
type Actions = typeof actions;
type StoreApi = StoreActionApi<State>;

const getCompanyProductOptionsCachedKey = (
  companyId: string,
  state: string
) => {
  return `CompanyProductOptionsCachedKey-${companyId}~${state}`;
};

const setDefaultState =
  () =>
    ({ setState }: StoreApi) => {
      setState(defaultState);
    };

// const getProductTabSortOrder = (productTypeCode: string) => {
//   let sortOrder = 0;
//   switch (productTypeCode) {
//     case ProductType.Aal:
//       sortOrder = ProductTabSortOrder.Aal;
//       break;
//     case ProductType.Cpl:
//       sortOrder = ProductTabSortOrder.Cpl;
//       break;
//     case ProductType.Jacket:
//       sortOrder = ProductTabSortOrder.Jacket;
//       break;
//     case ProductType.StandaloneEndorsement:
//       sortOrder = ProductTabSortOrder.StandaloneEndorsement;
//       break;
//     case ProductType.TitleSearch:
//       sortOrder = ProductTabSortOrder.TitleSearch;
//       break;      
//     default:
//       sortOrder = 0;
//       break;                      
//   }

//   return sortOrder;
// }
const setCompanyProductOptions =
  (data: any, companyId: string, state: string) => //, enableTitleSearch: boolean = false) =>
    ({ setState }: StoreApi) => {
      let productOptions: ProductOption[] = [];

      if (data && data.length > 0) {
        productOptions = data?.map((po: any) => {
          const option: ProductOption = {
            companyId: po.companyID,
            product: po.product,
            sortOrder: getProductTabSortOrder(po.product),
            formType: po.formType,
            state: po.state,
            approvedAttorney: po.approvedAttorney,
            secondaryAgency: po.secondaryAgency,
            settlementCompany: po.settlementCompany,
            printAttorneyOnly: po.printAttorneyOnly,
            municipalCode: po.municipalCode,
            lenderSuccessorLanguage: po.lenderSuccessorLanguage,
            additionalCharge: po.additionalCharge,
            specialCharge: po.specialCharge,
            premiumTax: po.premiumTax,
            riskRate: po.riskRate,
            transCode: po.transCode,
            default: po.default,
          };

          return option;
        });

        // TODO - 3/4/2025
        // Replace temporary Title Search product option with calling new SPACE api directly (should be from middle ware - Controller)
        // Temporay Title Search option
        // if (enableTitleSearch) {
        //   const titleSearchOption: ProductOption = {
        //     companyId: productOptions[0].companyId,
        //     product: ProductType.TitleSearch,
        //     sortOrder: getProductTabSortOrder(ProductType.TitleSearch),
        //     formType: "", 
        //     state: productOptions[0].state,
        //     approvedAttorney: undefined,
        //     secondaryAgency: undefined,
        //     settlementCompany: undefined,
        //     printAttorneyOnly: undefined,
        //     municipalCode: undefined,
        //     lenderSuccessorLanguage: undefined,
        //     additionalCharge: undefined,
        //     specialCharge: undefined,
        //     premiumTax: undefined,
        //     riskRate: undefined,
        //     transCode: undefined,
        //     default: 0,
        //   };
        //   productOptions.push(titleSearchOption);
        // }        

      }

      setState({
        isLoadingStateProductConfig: false,
        stateProductConfig: {
          companyId: companyId,
          stateAbbr: state,
          productOptions: orderBy(productOptions, "sortOrder"),
        },
      });
    };

const actions = {
  getCompanyProductOptions:
    (companyId: string, state: string) =>  //, enableTitleSearch: boolean = false, titleSearchConfigActionResult: ActionResult | null | undefined) =>
      async ({ setState, getState, dispatch }: StoreApi) => {
        try {
          if (!companyId || !state) return [];

          const cachedKey = getCompanyProductOptionsCachedKey(companyId, state);
          const cachedData = sessionStorage.getItem(cachedKey);

          if (cachedData) {
            dispatch(
              setCompanyProductOptions(JSON.parse(cachedData), companyId, state), // , enableTitleSearch)
            );
          } else {
            const token = getState().axiosCancelToken;
            if (token)
              token.cancel("getProductOptions canceled due to new request");

            const newCancelToken = cancelToken.source();
            setState({ axiosCancelToken: newCancelToken });

            var url = `/Company/GetProductOptions?CompanyID=${companyId}&State=${state}`;

            setState({
              isLoadingStateProductConfig: true,
            });

            const { data } = await axiosSecuredInstance.get<any>(url, {
              cancelToken: newCancelToken.token,
            });

            sessionStorage.setItem(cachedKey, JSON.stringify(data));
            dispatch(setCompanyProductOptions(data, companyId, state)); //, enableTitleSearch));
          }
        } catch (error) {
          setState({
            isLoadingStateProductConfig: false,
          });
          console.error("ERROR: ProductOptions.", error);
          return [];
        }
      },
  resetCompanyProductOptions:
    () =>
      ({ dispatch }: StoreApi) => {
        dispatch(setDefaultState());
      },
};

const defaultState = {
  isLoadingStateProductConfig: false,
  stateProductConfig: {
    companyId: undefined,
    stateAbbr: undefined,
    productOptions: [],
  },
};

const Store = createStore<State, Actions>({
  initialState: defaultState,
  actions,
  name: "companyProductOptions",
});

const hook = createHook(Store);
export const useCompanyProductOptions = () => { return hook(); };
